import { connect } from 'react-redux';

import { IApplicationState } from '../../types/redux';
import { getCoworkingPageTitle } from '../../utils/getCoworkingPageTitle';

import { Header as HeaderComponent } from './Header';
import { IHeaderContainerProps } from './types';

export const mapStateToProps = (state: IApplicationState): IHeaderContainerProps => ({
  coworkingName: getCoworkingPageTitle(state.coworking),
});

export const Header = connect(mapStateToProps)(HeaderComponent);
